<template>
  <div class="select-region select-region-box">
    <div class="select-region--main">
      <div class="select-region--title">
        Change Region
      </div>
      <!-- 取值用 -->
      <input
        id="region-checked"
        type="text"
        :value="checked"
        class="region-checked-value"
      >
      <ul class="region-list">
        <li
          v-for="item in regionList"
          :key="item.country"
          class="region-item"
          @click="onChecked(item.country)"
        >
          <div class="region-name">
            <img
              class="region-flag"
              :src="getFlagUrl(item.country)"
              :alt="item.label"
            >
            <span class="region-label">{{ item.label }}</span>
          </div>

          <Checkbox
            :value="checked === item.country"
            :name="item.country"
            @click="onChecked"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { REGION_LIST } from '@ms/setting'
import Checkbox from '../Checkbox'

export default {
  name: 'SelectRegionBox',
  components: {
    Checkbox
  },
  data() {
    return {
      checked: this.$region,
      regionList: REGION_LIST
    }
  },
  activated() {
    this.checked = this.$region
  },
  methods: {
    onChecked(name) {
      this.checked = name
      this.$emit('checked', name)
    },
    getFlagUrl(country) {
      return `${process.env.VUE_APP_CDN}images/flags/${country}.png`
    }
  }
}
</script>

<style lang="less">
.select-region {
  box-sizing: border-box;
  margin: 0 auto;
  color: #333;
  text-align: center;

  &--main {
    padding: 30px;
    margin: 0 auto;
  }

  &--title {
    margin-bottom: 20px;
    font-size: 20px;
    line-height: 24px;
  }
}

.region-list {
  .region-item {
    display: flex;
    height: 44px;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    line-height: 44px;

    .region-label {
      margin-left: 6px;
      vertical-align: middle;
    }
  }

  .region-flag {
    width: 30px;
    vertical-align: middle;
  }

  .checkbox {
    img {
      vertical-align: top;
    }
  }
}

.region-checked-value {
  position: absolute;
  width: 0;
  height: 0;
  border: 0;
  font-size: 0;
  line-height: 0;
  visibility: hidden;
}
</style>
